// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";

import App from "./components/App";
import {Provider, themes} from "@fluentui/react-northstar"; //https://fluentsite.z22.web.core.windows.net/quick-start
import {combineReducers, createStore} from 'redux'
import {Provider as P} from 'react-redux'
import * as serviceWorker from './serviceWorker'

import languageReducer from './store/languageReducer'

const store = createStore(
    combineReducers({
        languageReducer,
    }), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
ReactDOM.render(
    <P store={store}>
        <Provider theme={themes.teams}>
            <App/>
        </Provider>
    </P>
    ,
    document.getElementById("root")
);
serviceWorker.unregister()